var React = require('react');

function DownloadInProgress (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"9","stroke":"#737373","strokeWidth":"2","key":0}),React.createElement("mask",{"id":"mask0_531_21254","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"12","y":"2","width":"10","height":"20","key":1},React.createElement("path",{"d":"M12 2H22V22L12 12V2Z","fill":"#D9D9D9"})),React.createElement("g",{"mask":"url(#mask0_531_21254)","key":2},React.createElement("circle",{"cx":"12","cy":"12","r":"9","stroke":"#EA6C13","strokeWidth":"2"})),React.createElement("rect",{"x":"8","y":"8","width":"8","height":"8","fill":"#EA6C13","key":3})]);
}

DownloadInProgress.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = DownloadInProgress;

DownloadInProgress.default = DownloadInProgress;
